function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.692.704l6.791 6.787c1.131 1.13.277 2.558-1.314 2.558v6.36c0 .878-.708 1.591-1.58 1.591H3.402a1.585 1.585 0 0 1-1.579-1.59V9.942C.258 9.918-.615 8.613.508 7.49L7.3.704a2.396 2.396 0 0 1 3.392 0zm-2.28 1.129L1.82 8.395l.792.001c.44 0 .79.357.79.798v7.215h3.23a.802.802 0 0 1-.007-.102V12.31c0-1.31 1.064-2.371 2.37-2.371a2.373 2.373 0 0 1 2.37 2.37v3.997a.799.799 0 0 1-.007.102h3.231V9.194c0-.443.354-.798.79-.798h.787L9.58 1.833a.823.823 0 0 0-1.167 0z",
  fillRule: "evenodd"
});

var SvgHouse = function SvgHouse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/House.367e363e.svg";
export { ForwardRef as ReactComponent };